import useSectionData from './useSectionData';
import { SECTION_ENDPOINTS } from '@/Services/sectionApi';
import { contact, sectionErrors } from '@/data/content';

const initialContact = {
    carousel: {
        title: contact.info.default_section_title,
        background_image: '/Design/images/home_bg.png',
    },
    info: {
        cards: [],
        form_title: contact.info.form_title,
    },
    holidays: [],
};

const useContactSectionData = () => useSectionData(SECTION_ENDPOINTS.contact, initialContact, sectionErrors.contact);

export default useContactSectionData;
